import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { refType } from '@material-ui/utils';
import { useId } from '@jpmuitk/utils';

function getClippedMask(mask, value, textAlign) {
  if (textAlign === 'right') {
    return mask.substring(0, value ? mask.length - value.length : mask.length);
  }

  return mask.substring(value ? value.length : 0);
}

function InputWithMask(props) {
  var ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      classes = props.classes,
      _props$mask = props.mask,
      mask = _props$mask === void 0 ? '' : _props$mask,
      className = props.className,
      value = props.value,
      idProp = props.id,
      inputRef = props.inputRef,
      style = props.style,
      textAlign = props.textAlign,
      other = _objectWithoutProperties(props, ["aria-label", "aria-labelledby", "classes", "mask", "className", "value", "id", "inputRef", "style", "textAlign"]);

  var id = useId(idProp);
  var spacerAndMask = [/*#__PURE__*/React.createElement("i", {
    key: value
  }, value), getClippedMask(mask, value, textAlign)];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement("input", _assign({
    className: className
  }, other, {
    "aria-label": classnames(ariaLabel, mask),
    "aria-labelledby": "".concat(ariaLabelledBy ? "".concat(ariaLabelledBy, " ") : '').concat(id),
    id: id,
    ref: inputRef,
    style: style,
    value: value
  })), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: classnames(classes.mask, className),
    style: style
  }, textAlign !== 'right' ? spacerAndMask : spacerAndMask.reverse()));
}

process.env.NODE_ENV !== "production" ? InputWithMask.propTypes = {
  /**
   * aria-label to be appended to the input aria-label
   */
  'aria-label': PropTypes.string,

  /**
   * aria-labelledby to be prepended to the input aria-labelledby
   */
  'aria-labelledby': PropTypes.string,

  /**
   * The className(s) of the component.
   */
  className: PropTypes.string,

  /**
   * Useful to extend the style applied to components.
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * the input id.
   */
  id: PropTypes.string,

  /**
   * @external - material-ui
   * Use this property to pass a ref callback to the native input component.
   */
  inputRef: refType,

  /**
   * The input mask.
   */
  mask: PropTypes.string,

  /**
   * Optional custom inline style to attach to input component.
   */
  style: PropTypes.objectOf(PropTypes.string),

  /**
   *
   * Determines the alignment of the input text.
   */
  textAlign: PropTypes.oneOf(['left', 'right']),

  /**
   * @external - material-ui
   * The input value, required for a controlled component.
   */
  value: PropTypes.string
} : void 0;
export default InputWithMask;